// 财务总表
<template>
  <div class="threeLevelMain">
    <!-- 查询区域 -->
    <div class="queryBox clearfix">
      <div class="query_row" v-show="!isFoldQuery">
        <!-- <div class="scan_box">
          <span class="sp_scan_fixed">发生年份：</span>
          <el-date-picker
            type="year"
            v-model="queryForm.year"
            class="ip_scan"
            clearable
            size="mini"
            value-format="yyyy"
            @change="searchFunc"
          >
          </el-date-picker>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">发生日期：</span>
          <el-date-picker
            type="date"
            v-model="queryForm.occur_data"
            class="ip_scan"
            clearable
            size="mini"
            value-format="yyyy-MM-dd"
            @change="searchFunc"
          >
          </el-date-picker>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">发生月份：</span>
          <el-date-picker
            type="month"
            v-model="queryForm.month"
            class="ip_scan"
            clearable
            size="mini"
            value-format="yyyy-MM"
            @change="searchFunc"
          >
          </el-date-picker>
        </div> -->

        <div class="scan_box">
          <span class="sp_scan_fixed">报销人：</span>
          <el-input
            class="ip_scan"
            size="mini"
            @input="searchFunc"
            v-model="queryForm.reimburse_people"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">公司名称：</span>
          <el-input
            class="ip_scan"
            size="mini"
            @input="searchFunc"
            v-model="queryForm.company_name"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">旗舰店：</span>
          <el-input
            class="ip_scan"
            size="mini"
            @input="searchFunc"
            v-model="queryForm.flagship_store"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed" style="width:90px">所属费用部门：</span>
          <el-select
            v-model="queryForm.departmental_charge"
            class="ip_scan"
            size="mini"
            clearable
            @change="searchFunc"
          >
            <el-option
              v-for="dep in departmentOptions"
              :key="dep.value"
              :label="dep.label"
              :value="dep.value"
            ></el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">资金走向：</span>
          <el-select
            v-model="queryForm.money_to"
            class="ip_scan"
            clearable
            size="mini"
            @change="searchFunc"
          >
            <el-option
              v-for="(item, index) in moneyToOptions"
              :key="index"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">汇总明细：</span>
          <el-select
            v-model="queryForm.summary"
            placeholder="全部"
            class="ip_scan"
            clearable
            size="mini"
            @change="searchFunc"
          >
            <el-option-group
              v-for="group in summaryDelUseQuery.firstLevel"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed" style="width:90px">汇总二级明细：</span>
          <el-select
            v-model="queryForm.summary_two"
            placeholder="全部"
            class="ip_scan"
            clearable
            size="mini"
            @change="searchFunc"
          >
            <el-option-group
              v-for="group in summaryDelUseQuery.secondLevel"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">事项明细：</span>
          <el-input
            class="ip_scan"
            size="mini"
            @input="searchFunc"
            v-model="queryForm.matter_details"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">汇款名：</span>
          <el-input
            class="ip_scan"
            size="mini"
            @input="searchFunc"
            v-model="queryForm.remitter_name"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">收入金额：</span>
          <el-input
            class="ip_scan"
            size="mini"
            @input="searchFunc"
            v-model="queryForm.revenue"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">支出金额：</span>
          <el-input
            class="ip_scan"
            size="mini"
            @input="searchFunc"
            v-model="queryForm.expense"
          ></el-input>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">银行名称：</span>
          <el-select
            v-model="queryForm.bank_name"
            class="large_select"
            clearable
            size="mini"
            @change="searchFunc"
          >
            <el-option
              v-for="b in $store.state.bankNameOptions"
              :key="b.value"
              :label="b.label"
              :value="b.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="query_row" v-show="!isFoldQuery">
        <h3 class="fontSize_16 fontColor_theme mt-5 mb-5">区间类筛选</h3>
        <div class="scan_box">
          <span class="sp_scan_fixed" style="width:90px">填写月份区间：</span>
          <el-date-picker
            v-model="queryForm.monthRange"
            type="monthrange"
            align="right"
            unlink-panels
            range-separator="-"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            size="mini"
            value-format="yyyy-MM"
            @change="searchFunc"
            :picker-options="pickerOptions_month"
          >
          </el-date-picker>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed" style="width:90px">发生日期区间：</span>
          <el-date-picker
            v-model="queryForm.occDateRange"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
            value-format="yyyy-MM-dd"
            @change="searchFunc"
            :picker-options="pickerOptions_date"
          >
          </el-date-picker>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">收入区间：</span>
          <div class="input_s">
            <el-input
              size="mini"
              v-model="queryForm.revenueStart"
              @input="searchFunc"
              placeholder="最小值"
            ></el-input>
            <span class="mid">~</span>
            <el-input
              size="mini"
              v-model="queryForm.revenueEnd"
              @input="searchFunc"
              placeholder="最大值"
            ></el-input>
          </div>
        </div>
        <div class="scan_box">
          <span class="sp_scan_fixed">支出区间：</span>
          <div class="input_s">
            <el-input
              size="mini"
              v-model="queryForm.expenseStart"
              @input="searchFunc"
              placeholder="最小值"
            ></el-input>
            <span class="mid">~</span>
            <el-input
              size="mini"
              v-model="queryForm.expenseEnd"
              @input="searchFunc"
              placeholder="最大值"
            ></el-input>
          </div>
        </div>
      </div>
      <!-- 按钮区域 -->
      <div class="btn_area_out" v-show="!isFoldQuery">
        <el-button size="mini" @click="resetSearch">
          重置查询
        </el-button>

        <el-button size="mini" @click="openDialog">
          添加信息
        </el-button>

        <el-button size="mini" @click="openExport">
          导出看板
        </el-button>

        <el-button size="mini" @click="openExportSecond">
          导出利润表
        </el-button>

        <el-button size="mini" @click="exportFinSummary">
          导出总表
        </el-button>

        <el-button size="mini" @click="recalculateBtn" type="danger" v-if="jur">
          重新计算
        </el-button>

        <!-- <div class="import_area" v-if="$store.state.department == 7">
                    <el-button
                    size="mini"
                    @click="openExport"
                    >
                        导入信息
                    </el-button>
                    <input 
                    type="file" 
                    ref="importDom" 
                    class="import_file little_hands" 
                    @change="importHandle">
                </div> -->
      </div>
      <!-- 折叠区域 -->
      <div class="fold_btn">
        <!-- 展开 -->
        <div
          class="f_open_area little_hands"
          @click="isFoldQuery = !isFoldQuery"
          v-show="!isFoldQuery"
        >
          <el-button
            type="text"
            icon="el-icon-arrow-up"
            class="btn_icon_s"
          ></el-button>
          <p class="fold_content">收起</p>
        </div>
        <!-- 折叠 -->
        <div class="f_fold_area" v-show="isFoldQuery">
          <h3>筛选区域</h3>
          <div
            class="f_f_content little_hands"
            @click="isFoldQuery = !isFoldQuery"
          >
            <p class="fold_content">展开</p>
            <el-button
              type="text"
              icon="el-icon-arrow-down"
              class="btn_icon_s"
            ></el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 合计展示 -->
    <div class="account-view">
      <div class="ac-result">
        <span class="label">收入：</span>
        <countTo
          class="cn_num"
          :startVal="0"
          :endVal="moneyAccount.revenue"
          :decimals="2"
          :duration="1000"
        ></countTo>
      </div>
      <div class="ac-result">
        <span class="label">支出：</span>
        <countTo
          class="cn_num"
          :startVal="0"
          :endVal="moneyAccount.expense"
          :decimals="2"
          :duration="1000"
        ></countTo>
      </div>
      <span class="tips">最近一次重新计算时间：{{ recalculateTime }}</span>
    </div>
    <!-- 内容区域 -->
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :getDataConfig="dataQueryFunc()"
      :updateDataSignObj="{
        updateDataTag,
        resetPageNum,
      }"
      @setResetPageNum="setRPN"
      :totalCount="totalCount"
      :recalculateTag="isFoldQuery"
    >
      <el-table-column
        slot="departmental_charge"
        width="100"
        label="所属费用部门"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            {{
              departmentOptions.filter(
                (r) => r.value == scope.row.departmental_charge
              )[0].label
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        slot="summary"
        width="90"
        align="center"
        label="汇总明细"
      >
        <template slot-scope="scope">
          <div>
            {{
              sumDetailsItems.filter(
                (item) => item.value === scope.row.summary
              )[0].label
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        slot="summary_two"
        width="100"
        align="center"
        label="汇总二级明细"
      >
        <template slot-scope="scope">
          <div>
            {{
              sumDetailsItems.filter(
                (item) => item.value === scope.row.summary_two
              )[0].label
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        slot="bank_name"
        width="125"
        align="center"
        label="银行名称"
      >
        <template slot-scope="scope">
          <div>
            {{
              $store.state.bankNameOptions.filter(
                (item) => item.value === scope.row.bank_name
              )[0].label
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        slot="revise_handle"
        width="80"
        align="center"
        label="操作"
      >
        <template slot-scope="scope">
          <div>
            <el-button
              type="text"
              @click="openDialog(false, scope.row)"
              class="fontColor_warning"
              >修改</el-button
            >
          </div>
        </template>
      </el-table-column>
    </tablePageComp>

    <!-- 信息操作窗口 -->
    <el-dialog
      :title="isAdd ? '添加信息' : '修改信息'"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="dialogClose"
    >
      <!-- 财务操作 -->
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="100px"
        label-position="top"
        :inline="true"
        size="small"
        class="form-main"
        :hide-required-asterisk="true"
      >
        <el-form-item
          label="填写日期"
          prop="time"
          class="formItems"
          v-if="isAdd"
        >
          <el-date-picker
            class="s_time"
            v-model="formData.time"
            type="date"
            :disabled="true"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发生日期" prop="occur_data" class="formItems">
          <el-date-picker
            class="s_time"
            v-model="formData.occur_data"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="报销人" prop="reimburse_people" class="formItems">
          <el-input v-model.trim="formData.reimburse_people"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="company_name" class="formItems">
          <el-input v-model="formData.company_name"></el-input>
        </el-form-item>
        <el-form-item label="旗舰店" prop="flagship_store" class="formItems">
          <el-input v-model="formData.flagship_store"></el-input>
        </el-form-item>
        <el-form-item
          label="所属费用部门"
          prop="departmental_charge"
          class="formItems"
        >
          <el-select
            v-model="formData.departmental_charge"
            @change="departChange"
          >
            <el-option
              v-for="dep in departmentOptions"
              :key="dep.value"
              :label="dep.label"
              :value="dep.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资金走向" prop="money_to" class="formItems">
          <el-select v-model="formData.money_to">
            <el-option
              v-for="(item, index) in moneyToOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="汇总明细" prop="summary" class="formItems">
          <el-select v-model="formData.summary">
            <el-option-group
              v-for="group in sumDetailsOptions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="汇总二级明细" prop="summary_two" class="formItems">
          <el-select v-model="formData.summary_two">
            <el-option-group
              v-for="group in sumDetailsOptionsTwo"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="事项明细" prop="matter_details" class="formItems">
          <el-input v-model="formData.matter_details"></el-input>
        </el-form-item>

        <el-form-item label="银行名称" prop="bank_name" class="formItems">
          <!-- <el-form-item label="银行名称" prop="bank_name" class="formItems" v-if="isAdd"> -->
          <el-select v-model="formData.bank_name" class="bank_select">
            <el-option
              v-for="b in $store.state.bankNameOptions"
              :key="b.value"
              :label="b.label"
              :value="b.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="formItems"></el-form-item>
        <!-- <el-form-item class="formItems" v-if="isAdd"></el-form-item> -->
        <el-form-item label="汇款名" prop="remitter_name" class="formItems">
          <el-input v-model="formData.remitter_name"></el-input>
        </el-form-item>
        <el-form-item label="收入" prop="revenue" class="formItems">
          <el-input v-model="formData.revenue"></el-input>
        </el-form-item>
        <el-form-item label="支出" prop="expense" class="formItems">
          <el-input v-model="formData.expense"></el-input>
        </el-form-item>
        <!-- <el-form-item label="账户余额" prop="account_balance" class="formItems">
                <el-input v-model="formData.account_balance"></el-input>
            </el-form-item> -->
        <!-- <el-form-item label="总余额" prop="total_money" class="formItems">
                <el-input v-model="formData.total_money"></el-input>
            </el-form-item> -->
        <el-form-item label="备注" class="formItems">
          <el-input v-model="formData.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false" :loading="btnLoading"
          >取 消</el-button
        >
        <el-button
          type="primary"
          :loading="btnLoading"
          @click="submitForm('formData')"
          >提交</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="选择导出看板类型" :visible.sync="popUpVis" width="770px">
      <div class="select_box">
        <div class="export_type">
          <span class="e_t">导出类型：</span>
          <div class="all_type">
            <el-radio-group v-model="exportType" @change="exTypeChange">
              <el-radio label="1">银行余额看板</el-radio>
              <el-radio label="2">单个银行余额看板</el-radio>
              <el-radio label="3">费用明细分析看板</el-radio>
              <el-radio label="4">部门费用分析看板</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!-- 导出条件选择 -->
        <div class="export_condition">
          <div
            class="e_c_items"
            v-show="exportType == '1' || exportType == '2'"
          >
            <span class="ec_items_label">日期：</span>
            <el-date-picker
              size="small"
              v-model="exportParams.time"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
          <div class="e_c_items" v-show="exportType == '2'">
            <span class="ec_items_label">银行名称：</span>
            <el-select
              size="small"
              v-model="exportParams.bank_name"
              class="bn_select"
            >
              <el-option
                v-for="b in $store.state.bankNameOptions"
                :key="b.value"
                :label="b.label"
                :value="b.value"
              ></el-option>
            </el-select>
          </div>
          <div
            class="e_c_items"
            v-show="exportType == '3' || exportType == '4'"
          >
            <div class="select_item">
              <!-- <span class="ec_items_label">：</span> -->
              <el-select
                size="small"
                v-model="exportTimeType"
                style="width:100px"
                @change="exTypeChange"
              >
                <el-option label="按年份" value="0"></el-option>
                <el-option label="按月份" value="1"></el-option>
              </el-select>
            </div>
            <el-card>
              <!-- <div class="select_item" v-show="exportTimeType == '0'"> -->
              <div class="select_item">
                <span class="ec_items_label">年份：</span>
                <el-select size="small" v-model="exportParams.year">
                  <el-option
                    v-for="y in yearOptions"
                    :key="y"
                    :label="y"
                    :value="y"
                  ></el-option>
                </el-select>
              </div>
              <div class="select_item" v-show="exportTimeType == '1'">
                <span class="ec_items_label">月份：</span>
                <el-date-picker
                  size="small"
                  type="month"
                  value-format="MM"
                  clearable
                  v-model="exportParams.month"
                >
                </el-date-picker>
              </div>
            </el-card>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="popUpVis = false">取 消</el-button>
        <el-button type="primary" @click="exportBtn">确定</el-button>
      </div>
    </el-dialog>

    <!-- 导出利润表 -->
    <el-dialog title="选择年份" :visible.sync="exportISVis" width="400px">
      <div class="select_box">
        <!-- <div class="export_type">
                <span class="e_t">导出类型：</span>
                <div class="all_type">
                    <el-radio-group v-model="exportISType">
                        <el-radio label="1">年度利润表</el-radio>
                        <el-radio label="2">季度利润表</el-radio>
                    </el-radio-group>
                </div>
            </div> -->
        <!-- 导出条件选择 -->
        <div class="export_condition">
          <div class="e_c_items">
            <span class="ec_items_label">年份：</span>
            <el-date-picker
              size="small"
              v-model="exportISParams.year"
              type="year"
              value-format="yyyy"
              placeholder="选择年份"
              class="picker_sty"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="exportISVis = false" size="small">取 消</el-button>
        <el-button type="primary" @click="exportISBtn" size="small"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/libs/utils.js";
import countTo from "vue-count-to";
import moment from "moment";
export default {
  components: { countTo },
  data() {
    let userId = utils.sessionGetStore("user_id");
    let userName = utils.sessionGetStore("user_name");
    let numberValidate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入内容"));
      } else {
        // 保留两位小数
        if (/^(([1-9][0-9]*)|((([1-9][0-9]*)|0)\.[0-9]{1,2}))$/.test(value)) {
          callback();
        } else {
          callback(new Error("请输入纯数字或保留2位小数"));
        }
      }
    };
    return {
      isFoldQuery: false,
      userId: userId,
      userName,
      // 列表查询条件
      queryForm: {
        // occur_data: "", // 发生日期
        // month: "", // 发生月份
        monthRange: [], // 月份区间
        occDateRange: [],
        // year: "",
        reimburse_people: "", // 报销人
        company_name: "",
        flagship_store: "", // 旗舰店
        departmental_charge: "", // 所属部门
        money_to: "", // 资金走向
        summary: "", // 汇总明细
        summary_two: "", // 汇总二级明细
        matter_details: "", // 事项明细
        remitter_name: "", // 汇款名
        bank_name: "", // 银行名称

        revenue: "", // 收入-具体金额
        expense: "", // 支出-具体金额
        revenueStart: "", //收入区间
        revenueEnd: "",
        expenseStart: "", //支出区间
        expenseEnd: "",
      },
      // 表格内容相关
      dataList: [],
      updateDataTag: false,
      resetPageNum: true, // 是否重置页面
      totalCount: 0, // 数据总条数
      columnsList: [
        {
          label: "修改操作",
          slotName: "revise_handle",
        },
        {
          label: "填写日期",
          prop: "time",
          width: 90,
          formatter: (value) => {
            return value ? value.split(" ")[0] : "";
          },
        },
        {
          label: "发生日期",
          prop: "occur_data",
          width: 90,
        },
        {
          label: "报销人",
          prop: "reimburse_people",
          width: 90,
        },
        {
          label: "公司名称",
          prop: "company_name",
          width: 100,
        },
        {
          label: "旗舰店",
          prop: "flagship_store",
          width: 100,
        },
        {
          label: "所属费用部门",
          slotName: "departmental_charge",
        },
        {
          label: "资金走向",
          prop: "money_to",
          width: 80,
        },
        {
          label: "汇总明细",
          slotName: "summary",
        },
        {
          label: "汇总二级明细",
          slotName: "summary_two",
        },
        {
          label: "事项明细",
          prop: "matter_details",
          width: 120,
        },
        {
          label: "汇款名",
          prop: "remitter_name",
          width: 100,
        },
        {
          label: "银行名称",
          slotName: "bank_name",
        },
        {
          label: "收入",
          prop: "revenue",
          width: 90,
        },
        {
          label: "支出",
          prop: "expense",
          width: 90,
        },
        // {
        //     label:"账户余额",
        //     prop:"account_balance",
        //     width: 100
        // },
        {
          label: "总余额",
          prop: "total_money",
          width: 90,
        },
        {
          label: "备注",
          prop: "remark",
          width: 100,
        },
        {
          label: "提交人",
          prop: "submitter",
          width: 70,
        },
        {
          label: "添加时间",
          prop: "add_time",
          width: 150,
        },
      ],

      // 弹窗相关
      dialogVisible: false,
      isAdd: true, // 是否是添加信息操作
      formData: {
        time: "", // 日期
        occur_data: "", // 发生日期
        reimburse_people: "", // 报销人
        company_name: "", // 公司名称
        flagship_store: "", // 旗舰店
        departmental_charge: "", // 所属费用部门
        money_to: "", // 资金走向
        summary: "", // 汇总明细
        summary_two: "", // 汇总二级明细
        matter_details: "", // 事项明细
        remitter_name: "", // 汇款名
        bank_name: "", // 银行名称
        revenue: "0.00", // 收入
        expense: "0.00", // 支出
        // total_money: '0.00', // 总余额  可用余额
        // account_balance: '0.00', // 账户余额
        remark: "",

        // 待修改信息id
        id: "",
      },
      rules: {
        time: [{ required: true, message: "请填入日期", trigger: "change" }],
        occur_data: [
          { required: true, message: "请填入发生日期", trigger: "change" },
        ],
        reimburse_people: [
          { required: true, message: "请填入报销人", trigger: "blur" },
        ],
        // company_name: [
        //     { required: true, message: '请填入公司名称',trigger: 'blur' }
        // ],
        // flagship_store: [
        //     { required: true, message: '请填入旗舰店',trigger: 'blur' }
        // ],
        departmental_charge: [
          { required: true, message: "请填入所属费用部门", trigger: "change" },
        ],
        money_to: [
          { required: true, message: "请填入资金走向", trigger: "change" },
        ],
        summary: [
          { required: true, message: "请填入汇总明细", trigger: "change" },
        ],
        summary_two: [
          { required: true, message: "请填入汇总二级明细", trigger: "change" },
        ],
        matter_details: [
          { required: true, message: "请填入事项明细", trigger: "blur" },
        ],
        // remitter_name: [
        //     { required: true, message: '请填入汇款名',trigger: 'blur' }
        // ],
        bank_name: [
          { required: true, message: "请填入银行名称", trigger: "change" },
        ],
        revenue: [{ validator: numberValidate, trigger: "blur" }],
        expense: [{ validator: numberValidate, trigger: "blur" }],
        // total_money: [
        //     { validator: numberValidate, trigger: 'blur' },
        // ],
        // account_balance: [
        //     { validator: numberValidate, trigger: 'blur' },
        // ],
      },

      // 一级汇总明细初始
      sdOptionsInit: [
        // 示例
        // {
        //     label: '总经办',
        //     options: [
        //         {
        //             value: 'z-1',
        //             label: '租金'
        //         },
        //         {
        //             value: 'z-2',
        //             label: '物业费'
        //         },
        //         {
        //             value: 'z-3',
        //             label: '水电费'
        //         },
        //         {
        //             value: 'z-4',
        //             label: '快递费'
        //         },
        //         {
        //             value: 'z-5',
        //             label: '其他'
        //         },
        //     ]
        // },
      ],
      // 二级汇总明细初始
      sdOptionsInitTwo: [],
      // 汇总一级明细
      sumDetailsOptions: [],
      // 汇总二级明细
      sumDetailsOptionsTwo: [],
      sumDetailsItems: [], // 所有一二级汇总明细，便于筛选

      btnLoading: false,
      moneyToOptions: [
        {
          label: "收入",
          value: "收入",
        },
        {
          label: "费用",
          value: "费用",
        },
        {
          label: "往来款",
          value: "往来款",
        },
        {
          label: "借款",
          value: "借款",
        },
      ],

      // 导出信息弹窗
      popUpVis: false,
      exportType: "1", // 导出类型 默认第一个
      exportParams: {
        time: "",
        year: "",
        bank_name: "",
        month: "",
      },
      exportTimeType: "0", // 0-按年份 1-按月份
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      yearOptions: [],

      // 导出利润表
      exportISVis: false,
      exportISType: "1", // 1-年度  2-季度
      exportISParams: {
        year: "",
      },

      // 合计内容
      moneyAccount: {
        expense: 0, // 支出
        revenue: 0, // 收入
      },
      monthAccountVis: false, // 月度累计额展示
      pickerOptions_month: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      pickerOptions_date: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      jur: false, // 重新计算功能权限
      recalculateTime: "", // 上次重新计算时间
    };
  },
  computed: {
    // 部门配置项
    departmentOptions() {
      return [
        ...this.$store.state.commonOptions.department,
        {
          label: "未确定",
          value: "8",
        },
      ];
    },

    // 筛选功能中，汇总明细与费用部门的联动
    summaryDelUseQuery() {
      let dep = this.departmentOptions.filter(
        (item) => item.value == this.queryForm.departmental_charge
      )[0]?.label;
      if (dep) {
        return {
          firstLevel: this.sdOptionsInit.filter((item) => item.label == dep),
          secondLevel: this.sdOptionsInitTwo.filter(
            (item) => item.label == dep
          ),
        };
      } else {
        return {
          firstLevel: this.sdOptionsInit,
          secondLevel: this.sdOptionsInitTwo,
        };
      }
    },
  },
  created() {
    this.sdOptionsInit = JSON.parse(utils.sessionGetStore("s"));
    this.sdOptionsInitTwo = JSON.parse(utils.sessionGetStore("st"));

    this.sdOptionsInit.forEach((item) => {
      this.sumDetailsItems.push(...item.options);
    });
    this.sdOptionsInitTwo.forEach((item) => {
      this.sumDetailsItems.push(...item.options);
    });
    // console.log(this.sumDetailsItems)
    // 为什么当时没有直接用el-date-picker，idiot，先不改 2023.6.21
    let date = new Date();
    for (let i = 0; i < 5; i++) {
      this.yearOptions.push(date.getFullYear() - i);
    }
    // this.queryForm.year = String(this.yearOptions[0]);
    // 默认查看当前年
    this.queryForm.occDateRange = this.nowYear();
    this.jur = utils.sessionGetStore("jurisdiction") === "0" ? true : false;
  },
  methods: {
    nowYear() {
      let now = new Date();
      let startYear = moment(now)
        .startOf("year")
        .format("YYYY-MM-DD");
      let endYear = moment(now)
        .endOf("year")
        .format("YYYY-MM-DD");
      return [startYear, endYear];
    },
    // 重新计算
    recalculateBtn() {
      const loading = this.$loading({
        lock: true,
        text: "正在重新计算，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      api
        .recalculateFunc()
        .then((res) => {
          // console.log(res)
          if (res.data.code === 0) {
            utils.notificationInfo("消息", res.data.msg, "success");
            this.updateDataTag = !this.updateDataTag;
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    setRPN(e) {
      this.resetPageNum = e;
    },
    // 导入
    importHandle(e) {
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      this.$refs.importDom.value = null;

      const loading = this.$loading({
        lock: true,
        text: "导入中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      api
        .importFinancialSum(formData)
        .then((res) => {
          loading.close();
          // console.log(res)
          if (res.data.code == 0) {
            utils.notificationInfo("消息", "已导入", "success");
            this.updateDataTag = !this.updateDataTag;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((error) => {
          loading.close();
          console.log(error);
        });
    },
    // 导出财务总表
    exportFinSummary() {
      let paramObj = {
        ...this.queryParamsFunc(),
      };
      const loading = this.$loading({
        lock: true,
        text: "正在导出",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      api
        .exportFinancialSum(paramObj)
        .then((res) => {
          // console.log(res)
          loading.close();
          utils.downloadFile(res);
        })
        .catch((err) => {
          console.log(err);
          loading.close();
          this.$message.error("导出失败");
        });
    },
    openExportSecond() {
      this.exportISVis = true;
      this.exportISParams.year = String(new Date().getFullYear());
    },
    exportISBtn() {
      if (!this.exportISParams.year) {
        this.$message.warning("未选择年份");
        return;
      }
      let paramObj = {};
      Object.keys(this.exportISParams).forEach((key) => {
        if (this.exportISParams[key]) {
          paramObj[key] = this.exportISParams[key];
        }
      });
      const loading = this.$loading({
        lock: true,
        text: "正在导出",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      api
        .exportIncomeList(paramObj)
        .then((res) => {
          // console.log(res)
          loading.close();
          utils.downloadFile(res);
          this.exportISVis = false;
        })
        .catch((err) => {
          console.log(err);
          loading.close();
          this.$message.error("导出失败");
        });
    },

    // 导出类型变化
    exTypeChange() {
      Object.keys(this.exportParams).forEach((key) => {
        this.exportParams[key] = "";
      });
    },
    exportBtn() {
      // 导出单个银行余额信息，银行名称为必选
      if (this.exportType == "2" && this.exportParams.bank_name === "") {
        this.$message.warning("未选择银行");
        return;
      }
      if (this.exportType == "3" || this.exportType == "4") {
        if (this.exportTimeType == "0" && this.exportParams.year === "") {
          this.$message.warning("未选择年份");
          return;
        } else if (
          this.exportTimeType == "1" &&
          this.exportParams.month === ""
        ) {
          this.$message.warning("未选择月份");
          return;
        }
      }
      let paramObj = {};
      Object.keys(this.exportParams).forEach((key) => {
        if (this.exportParams[key]) {
          paramObj[key] = this.exportParams[key];
        }
      });

      let apiName = "";
      switch (this.exportType) {
        case "1":
          apiName = "exportAllAccountBal";
          break;
        case "2":
          apiName = "exportSingleAccountBal";
          break;
        case "3":
          this.exportTimeType == "0"
            ? (apiName = "exportCostAnalysis")
            : (apiName = "exportCostAnalysisMonth");
          break;
        case "4":
          this.exportTimeType == "0"
            ? (apiName = "exportDepCostAnalysis")
            : (apiName = "exportDepCostAnalysisMonth");
          break;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在导出",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      api[apiName](paramObj)
        .then((res) => {
          // console.log(res)
          loading.close();
          utils.downloadFile(res);
          this.popUpVis = false;
        })
        .catch((error) => {
          console.log(error);
          loading.close();
          this.$message.error("数据中含有未确定项，停止导出");
        });
    },

    // 导出窗口
    openExport() {
      this.popUpVis = true;
      Object.keys(this.exportParams).forEach((key) => {
        this.exportParams[key] = "";
      });
    },

    searchFunc() {
      //   console.log(this.queryForm);
      if (this.queryForm.revenueStart && this.queryForm.revenueEnd) {
        if (this.queryForm.revenueStart > this.queryForm.revenueEnd) {
          this.$message.warning("左边值应小于右边");
          return;
        }
      }
      if (this.queryForm.expenseStart && this.queryForm.expenseEnd) {
        if (this.queryForm.expenseStart > this.queryForm.expenseEnd) {
          this.$message.warning("左边值应小于右边");
          return;
        }
      }
      if (this.queryForm.month) this.monthAccountVis = true;
      utils.debounceFunc(
        function() {
          this.updateDataTag = !this.updateDataTag;
        }.bind(this),
        300
      );
    },

    //重置查询
    resetSearch() {
      Object.keys(this.queryForm).forEach((key) => {
        if (this.queryForm[key]) {
          this.queryForm[key] = "";
        }
      });
      //   this.queryForm.year = String(this.yearOptions[0]);

      this.queryForm.monthRange = [];
      this.queryForm.occDateRange = [];
      this.updateDataTag = !this.updateDataTag;
    },

    departChange() {
      this.setCurDepartSum();
      // 所属部门变化，汇总明细置空
      this.formData.summary = "";
      this.formData.summary_two = "";
    },

    // 设置当前部门对应的汇总明细
    setCurDepartSum() {
      let label = this.departmentOptions.filter(
        (item) => item.value == this.formData.departmental_charge
      )[0].label;
      this.sumDetailsOptions = this.sdOptionsInit.filter(
        (item) => item.label == label
      );
      this.sumDetailsOptionsTwo = this.sdOptionsInitTwo.filter(
        (item) => item.label == label
      );
    },

    //  弹窗添加信息
    openDialog(type = true, data) {
      this.dialogVisible = true;
      this.isAdd = type;

      // 默认设置全部明细
      this.sumDetailsOptions = this.sdOptionsInit;
      this.sumDetailsOptionsTwo = this.sdOptionsInitTwo;

      if (this.isAdd) {
        // 添加
        Object.keys(this.formData).forEach((key) => {
          // if(key == 'revenue' || key == 'expense' || key == 'total_money' || key == 'account_balance') {
          if (key == "revenue" || key == "expense") {
            this.formData[key] = "0.00";
          } else if (key == "time") {
            this.formData.time = utils.getNowTime().split(" ")[0];
          } else {
            this.formData[key] = "";
          }
        });
      } else {
        // 修改
        Object.keys(this.formData).forEach((key) => {
          if (data[key] == null || data[key] === "0" || !data[key]) {
            // if(key == 'revenue' || key == 'expense' || key == 'total_money' || key == 'account_balance') {
            if (key == "revenue" || key == "expense") {
              this.formData[key] = "0.00";
            } else {
              this.formData[key] = "";
            }
          } else {
            this.formData[key] = data[key];
          }
        });
        // 设置当前部门对应的汇总明细
        this.setCurDepartSum();
      }
    },

    // 确认提交信息----财务或市场部提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let paramObj = {};
          Object.keys(this.formData).forEach((key) => {
            if (this.formData[key]) {
              paramObj[key] = this.formData[key];
            }
          });
          this.btnLoading = true;
          let apiName = "";
          if (this.isAdd) {
            paramObj.submitter = this.userName;

            apiName = "addFinancialSumList";
          } else {
            // 修改
            apiName = "modifyFinancialSumList";
            this.resetPageNum = false;
          }
          api[apiName](paramObj)
            .then((res) => {
              // console.log(res)
              this.btnLoading = false;
              if (res.data.code === 0) {
                this.updateDataTag = !this.updateDataTag;
                this.dialogVisible = false;
                // utils.notificationInfo('提示','提交成功','success')
              } else {
                this.$message.warning(res.msg);
              }
            })
            .catch((error) => {
              console.log(error);
              this.btnLoading = false;
              this.$message.warning("信息提交失败");
            });
        } else {
          return false;
        }
      });
    },

    dialogClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 筛选参数处理
    queryParamsFunc() {
      let paramObj = {};
      Object.keys(this.queryForm).forEach((key) => {
        if (key == "monthRange") {
          if (
            this.queryForm.monthRange &&
            this.queryForm.monthRange.length > 0
          ) {
            paramObj.monthStart = this.queryForm.monthRange[0];
            paramObj.monthEnd = this.queryForm.monthRange[1];
          }
        } else if (key == "occDateRange") {
          if (
            this.queryForm.occDateRange &&
            this.queryForm.occDateRange.length > 0
          ) {
            paramObj.timeStart = this.queryForm.occDateRange[0];
            paramObj.timeEnd = this.queryForm.occDateRange[1];
          }
        } else {
          if (this.queryForm[key]) {
            paramObj[key] = this.queryForm[key];
          }
        }
      });
      return paramObj;
    },
    //表格数据获取
    dataQueryFunc() {
      //查询条件
      let paramObj = {
        ...this.queryParamsFunc(),
      };

      return {
        apiName: "getFinancialSumList",
        paramObj: paramObj,
        success: function(response, callBack) {
          // console.log(response)
          let records = response.data.data.list;
          let arr = [];
          for (let i = 0; i < records.length; i++) {
            let obj = records[i];

            Object.keys(obj).forEach((key) => {
              if (obj[key] == null || obj[key] == undefined) {
                obj[key] = "";
              }

              // 收入或支出为0.00时，显示为空
              if (
                (key == "revenue" || key == "expense") &&
                obj[key] === "0.00"
              ) {
                obj[key] = "";
              }
            });

            arr.push(obj);
          }
          this.dataList = arr;
          this.totalCount = response.data.data.totalCount;
          if (response.data.data.money) {
            this.moneyAccount.revenue = Number(
              response.data.data.money.revenue
            );
            this.moneyAccount.expense = Number(
              response.data.data.money.expense
            );
          } else {
            this.moneyAccount.revenue = 0;
            this.moneyAccount.expense = 0;
          }
          this.recalculateTime = response.data.data.time;
          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function(error, callBack) {
          if (callBack) {
            callBack();
          }
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.threeLevelMain {
  .queryBox {
    margin-bottom: 2px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    // 金额筛选
    .amount {
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        margin: 0 !important;
      }
    }
  }
  // 合计展示
  .account-view {
    padding: 5px;
    background-color: #fff;
    margin: 5px 0;
    display: flex;

    .ac-result {
      margin: 0 20px;
      > span {
        font-size: 16px;
      }
      .label {
        line-height: 1;
      }
      &:nth-child(2) {
        margin-left: 50px;
      }
      .cn_num {
        font-weight: bold;
        // color: #00B791;
        color: #0f70ee;
      }
    }
    .tips {
      color: #999;
      margin-top: 2px;
    }
  }
}
.form-main {
  // text-align: center;
  padding-left: 26px;

  .formItems {
    padding: 0 20px;
    padding-right: 40px;
    width: 30%;
    text-align: left;

    .s_time {
      width: 150px;
    }
    .bank_select {
      width: 350px;
    }
  }
}

// 选择导出看板类型样式
.select_box {
  padding: 0 20px;
  .export_type {
    .e_t {
      font-size: 15px;
      font-weight: bold;
    }
    .all_type {
      margin: 20px 0;
      padding: 0 20px;
    }
  }

  .export_condition {
    margin-top: 30px;
    .e_c_items {
      padding: 10px 20px;
      line-height: 30px;

      .ec_items_label {
        display: inline-block;
        width: 70px;
        text-align: right;
        padding-right: 5px;
      }
      .picker_sty {
        width: 180px;
      }
      .bn_select {
        width: 350px;
      }
      .select_item {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
